import { baseApi } from "@/Redux/api/baseApi";

const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    login: builder.mutation({
      query: (userInfo) => ({
        url: "/auth/login",
        method: "POST",
        body: userInfo,
      }),
    }),

    logOut: builder.mutation({
      query: () => ({
        url: "public/auth/logout",
        method: "POST",
      }),
    }),

    forgetPassword: builder.mutation({
      query: (data) => ({
        url: "/auth/forgot-password",
        method: "POST",
        body: data
      }),
    }),

    resetPassword: builder.mutation({
      query: (data) => ({
        url: "auth/reset-password",
        method: "POST",
        body: data
      }),
    }),


  }),
});

export const {
  useLoginMutation,
  useLogOutMutation,
  useForgetPasswordMutation,
  useResetPasswordMutation
} = authApi;
